import { useState } from "react";
import { MapPeekOverlay } from "./MapPeekOverlay.js";

export function MapPeekControl() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button type="button" className="map-peek-open" onClick={() => setOpen(true)}>
        マップを見る
      </button>
      {open && <MapPeekOverlay onClose={() => setOpen(false)} />}
    </>
  );
}
